/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Ladda from 'ladda';
import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';

import Session from '@/Session';
import { validateForm } from '@/util/ParsleyUtils';

import './SearchFieldsView.css';

import tmplSearchFieldsView from './SearchFieldsView.hbs';

const SearchFieldsView = View.extend({
  template: tmplSearchFieldsView,

  className: 'search-fields-view',

  ui: {
    btnReset: '.btn-reset',
    btnSearch: '.btn-search',
    selectField: '.form-select',
    datepicker: '.datepicker',
    searchFieldsForm: '.search-fields-form',
    multipleSelect: '.multiple-form-select'
  },

  events: {
    'click @ui.btnReset': 'onClickReset',
    'click @ui.btnSearch': 'onClickSearch'
  },

  triggers: {
    'search:response': 'search:response',
    'search:reset': 'search:reset'
  },

  onRender() {
    const userActingCommand = Session.user?.commandName;
    // this.ui.datepicker.datepicker({ format: 'yyyy-mm-dd' }); //NOTE: causes search fields to disappear
    this.ui.multipleSelect.select2({
      theme: 'bootstrap',
      placeholder: 'Command (Multi-select)',
      class: 'form-control'
    });
    this.ui.multipleSelect.attr('style', 'height:38px; font-size: 16px;');
    this.ui.multipleSelect.attr('data-parsley-errors-container', '#errorsContainer');
    this.ui.multipleSelect.val([userActingCommand]).trigger('change.select2');
  },

  toggleForm(state) {
    this.$el.find(':input').prop('disabled', !state);
  },

  onClickReset(e) {
    const userActingCommand = Session.user?.commandName;
    e.preventDefault();
    this.$el.find(':input').val('');
    this.triggerMethod('search:reset');
    this.ui.multipleSelect.val([userActingCommand]).trigger('change.select2');
  },

  trimFormDataStrings(formData) {
    for (const [key, value] of Object.entries(formData)) {
      if (typeof value === 'string') formData[key] = value.trim();
    }
  },

  async onClickSearch(e) {
    e.preventDefault();

    const formData = Syphon.serialize(this);
    if (this.model.get('commandId')) {
      formData.commandId = this.model.get('commandId');
    }

    if (formData.command) {
      formData.command = formData.command.join(',');
    }
    // trim whitespace from search fields
    this.trimFormDataStrings(formData);

    const spinner = Ladda.create(this.ui.btnSearch[0]);
    spinner.start();

    try {
      await validateForm(this.ui.searchFieldsForm);
      this.toggleForm(false);
      const response = await this.model.get('searchService')(formData);
      this.triggerMethod('search:response', response);
    } catch (err) {
      this.triggerMethod('search:error', err);
    } finally {
      spinner.stop();
      this.toggleForm(true);
    }
  }
});

export default SearchFieldsView;
